(() => {
  const STORAGE_KEY = "sillon-cart-hold";

  function pad(value) {
    return String(value).padStart(2, "0");
  }

  class SillonCartHold extends HTMLElement {
    connectedCallback() {
      this.minutes = Number(this.dataset.minutes || 30);
      this.storageKey = this.dataset.storageKey || STORAGE_KEY;
      this.fillEl = this.querySelector("[data-cart-hold-fill]");
      this.timeEl = this.querySelector("[data-cart-hold-time]");
      this.tick = this.tick.bind(this);
      this.tick();
      this.timer = window.setInterval(this.tick, 1000);
    }

    disconnectedCallback() {
      if (this.timer) window.clearInterval(this.timer);
    }

    getDeadline() {
      const stored = window.sessionStorage.getItem(this.storageKey);
      if (stored) return Number(stored);

      const deadline = Date.now() + this.minutes * 60 * 1000;
      window.sessionStorage.setItem(this.storageKey, String(deadline));
      return deadline;
    }

    tick() {
      const total = this.minutes * 60 * 1000;
      const remaining = Math.max(0, this.getDeadline() - Date.now());
      const fill = (remaining / total) * 100;
      const minutes = Math.floor(remaining / 60000);
      const seconds = Math.floor((remaining % 60000) / 1000);

      if (this.fillEl) this.fillEl.style.width = `${fill}%`;
      if (this.timeEl) {
        this.timeEl.textContent = `${pad(minutes)}:${pad(seconds)}`;
        this.timeEl.setAttribute("datetime", `PT${minutes}M${seconds}S`);
      }
    }
  }

  if (!window.customElements.get("sillon-cart-hold")) {
    window.customElements.define("sillon-cart-hold", SillonCartHold);
  }

  document.addEventListener("cart:change", (event) => {
    if (event.detail?.cart?.item_count === 0) {
      window.sessionStorage.removeItem(STORAGE_KEY);
    }
  });
})();
